import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface CreateRunFlowTaskParams {
  readonly scheduleId: string;
  readonly flowId: string;
  readonly runAllOutputs: boolean;
  readonly isRunAllIncremental: boolean;
  readonly flowOutputStepIds: string[];
  readonly flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
}

export class CreateRunFlowTaskRequest extends Request<CreateRunFlowTaskParams, IResult> {
  constructor(params: CreateRunFlowTaskParams) {
    super('createRunFlowTask', params);
  }
}
